// 배포 버전 정보 (vite define 으로 빌드 시 주입)
export const APP_VERSION = __APP_VERSION__;

/** 빌드 시각 KST 'YYYY-MM-DD HH:mm' */
function kstBuild(): string {
  try {
    return new Intl.DateTimeFormat('sv-SE', {
      timeZone: 'Asia/Seoul',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false,
    }).format(new Date(__BUILD_TIME__)).replace(' ', ' ');
  } catch {
    return '';
  }
}

/** 빌드 시각 KST 'YYYY-MM-DD HH:mm' */
export const BUILD_TIME_LABEL = kstBuild();

/** 화면 표시용 라벨: 'v0.1.0 · 2026-06-17 16:05' */
export const VERSION_LABEL = `v${APP_VERSION} · ${kstBuild()}`;
